var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlledAccessToSchools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 472.615 472.615",
    style: {
      enableBackground: "new 0 0 472.615 472.615"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "hovered-paths",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M372.143,202.291V135.84C372.143,60.941,311.204,0,236.304,0c-74.9,0-135.839,60.941-135.839,135.84v66.451h-61.14    v270.324h393.966V202.291H372.143z M307.454,202.291h-142.3V135.84c0-39.232,31.919-71.15,71.149-71.15    c39.231,0,71.15,31.918,71.15,71.15V202.291z",
    "data-original": "#000000",
    className: "hovered-path active-path",
    "data-old_color": "#000000",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlledAccessToSchools);
export default __webpack_public_path__ + "static/media/controlled-access-to-schools.8f1d923a336963770a736fcb18239f84.svg";
export { ForwardRef as ReactComponent };